import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          
          {/* About Section */}
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-4 text-ocean-blue">Whakapapa Whenua Hub</h3>
            <p className="text-gray-300 mb-4">
              Empowering Māori whānau to understand their customary rights, reconnect with whenua, 
              and strengthen their identity through whakapapa and cultural knowledge.
            </p>
            <div className="flex items-center text-gray-300">
              <Heart className="h-4 w-4 text-ocean-blue mr-2" />
              <span className="text-sm">Built with aroha for our whānau</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-ocean-blue">Kaupapa</h4>
            <ul className="space-y-2">
              <li><a href="/tangata-whenua-rights" className="text-gray-300 hover:text-white transition-colors">Tangata Whenua Rights</a></li>
              <li><a href="/tinorangatiratanga" className="text-gray-300 hover:text-white transition-colors">Tino Rangatiratanga</a></li>
              <li><a href="/he-whakaputanga" className="text-gray-300 hover:text-white transition-colors">He Whakaputanga</a></li>
              <li><a href="/whakapapa" className="text-gray-300 hover:text-white transition-colors">Whakapapa</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-ocean-blue">Whakapā</h4>
            <div className="space-y-3">
              <div className="flex items-center text-gray-300">
                <Mail className="h-4 w-4 mr-2" />
                <span className="text-sm">info@whakapapawhenua.org</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Phone className="h-4 w-4 mr-2" />
                <span className="text-sm">0800 WHENUA</span>
              </div>
              <div className="flex items-start text-gray-300">
                <MapPin className="h-4 w-4 mr-2 mt-0.5" />
                <span className="text-sm">Aotearoa New Zealand</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Whakapapa Whenua Hub. All rights reserved. 
            <span className="ml-2">Kia kaha, kia māia, kia manawanui</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
